import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimoniosDestacados, testimoniosExtra } from '../data/testimonials';
import { TestimonialCard } from './TestimonialCard';
export function Testimonials() {
  const loopTestimonios = [...testimoniosExtra, ...testimoniosExtra];
  return <section className="w-full bg-white py-20" data-id="element-165" data-mp="3b01hpf7u80u5">
      <div className="mx-auto max-w-6xl px-6 sm:px-10" data-id="element-166" data-mp="36ypokzpr8xh7">
        <h2 className="text-center font-heading text-3xl font-bold text-mint-dark sm:text-4xl" data-id="element-167" data-mp="370k767dk0di4">Lo que dicen mis pacientes</h2>
        <p className="mt-3 flex items-center justify-center gap-2 text-base text-gray-500" data-id="element-168" data-mp="3229024en8h3l">
          <span className="flex text-amber" data-id="element-169" data-mp="2x2mnlx6n34vu">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber" aria-hidden="true" data-id="element-170" data-mp="2s431nws1pt3h" data-mpi={i} />)}
          </span>
          4.9/5 · Más de 3.000 descargas verificadas
        </p>

        <div className="mt-14 grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3" data-id="element-171" data-mp="qb509ck7ds6x">
          {testimoniosDestacados.map((testimonial, index) => <motion.div key={testimonial.nombre} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-172" data-mp="m5kmoqccuxdh" data-mpi={index}>
              <TestimonialCard testimonial={testimonial} data-id="element-173" data-mp="zxqyk08h6i74" />
            </motion.div>)}
        </div>
      </div>

      <div className="mt-14 overflow-hidden border-t border-gray-100 py-10" data-id="element-174" data-mp="14ur4mb5brky8">
        <p className="mb-6 text-center text-sm font-medium uppercase tracking-wide text-gray-400" data-id="element-175" data-mp="q5v2svtv3462">Y muchas más pacientes felices</p>
        <div className="flex w-max animate-marquee gap-5 px-6" data-id="element-176" data-mp="v3mvhs2byubb">
          {loopTestimonios.map((testimonial, index) => <div key={`${testimonial.nombre}-${index}`} className="flex w-[300px] shrink-0 flex-col rounded-xl border border-gray-200 bg-gray-50 p-5" data-id="element-177" data-mp="1nlqqv4lfqgnt" data-mpi={index}>
              <div className="flex text-amber" data-id="element-178" data-mp="1siwe4jmhby8b">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber" aria-hidden="true" data-id="element-179" data-mp="1oh2kuwem5wi6" data-mpi={i} />)}
              </div>
              <p className="mt-2 text-sm italic leading-relaxed text-gray-700" data-id="element-180" data-mp="1jh6g2uy3e11k">“{testimonial.texto}”</p>
              <p className="mt-3 text-xs font-bold text-mint-dark" data-id="element-181" data-mp="1ejwslku9jzgd">
                {testimonial.nombre} | {testimonial.edad} años | {testimonial.ciudad}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}